import React from 'react';
import { Typography } from '@/lib/typography';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';

const mockData = [
  { stage: 'Generated', value: 12, color: 'hsl(var(--emerald-500))' },
  { stage: 'Scaffolded', value: 5, color: 'var(--brand-600)' },
  { stage: 'Promoted', value: 3, color: 'hsl(var(--emerald-700))' },
  { stage: 'Campaign', value: 4, color: 'hsl(var(--emerald-800))' }
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-[hsl(var(--gray-200))] rounded-lg p-3 shadow-sm">
        <p className="text-[hsl(var(--slate-700))]">{payload[0].payload.stage}</p>
        <p className="text-[hsl(var(--slate-400))]">
          Count: <span className="text-[hsl(var(--slate-700))]">{payload[0].value}</span>
        </p>
      </div>
    );
  }
  return null;
};

const CustomLabel = (props) => {
  const { x, y, width, height, value } = props;
  return (
    <text 
      x={x + width + 10} 
      y={y + height / 2} 
      fill="hsl(var(--slate-700))" 
      textAnchor="start" 
      dominantBaseline="middle"
      className="font-sans text-sm font-semibold"
    >
      {value}
    </text>
  );
};

export function ConversionFunnelChart() {
  return (
    <div className="bg-white rounded-lg border border-[hsl(var(--gray-200))] p-6 shadow-sm">
      <h3 className={Typography.h3}
        className="font-display"
      >
        Idea → Campaign Funnel
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart 
          data={mockData} 
          layout="vertical"
          margin={{ top: 5, right: 40, left: 80, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--gray-200))" />
          <XAxis 
            type="number" 
            stroke="hsl(var(--slate-400))"
            className="font-sans text-xs"
          />
          <YAxis 
            type="category" 
            dataKey="stage" 
            stroke="hsl(var(--slate-400))"
            className="font-sans text-xs"
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(229, 231, 235, 0.3)' }} />
          <Bar dataKey="value" radius={[0, 8, 8, 0]}>
            <LabelList dataKey="value" content={<CustomLabel />} />
            {mockData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
